import React from 'react';
import { Card, CardHeader } from '@progress/kendo-react-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';
import './NoRecordFound.scss';
/**
 * NoRecordFound component
 */
const NoRecordFound = ({ onExit, recordNotFoundText }) => {
  return (
    <Card className='tophead k-m-2'>
      <CardHeader>
        <h6 className='k-mb-0 k-text-center'>{recordNotFoundText}</h6>
        <div className='back-btn-wrapper'>
          <Button
            themeColor={'primary'}
            className='k-mx-1'
            onClick={() => onExit()}
          >
            <FontAwesomeIcon className='k-mr-2' icon={faArrowLeft} />
            Go Back
          </Button>
        </div>
      </CardHeader>
    </Card>
  );
};

export default NoRecordFound;
